module.exports = __webpack_public_path__ + "img/marketing-banner.65eadcdc.png";